import React, { useState, useEffect } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableCell,
  TablePagination,
  TableRow,
  TableHead,
  TableBody,
  Paper,
  TableContainer,
  Button,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
  obtenerClientesPorCampana,
  obtenerAlcanceDeCampana,
  obtenerAlcanceDeCampanaPorFecha,
  obtenerClientesPorCampanaFecha,
  obtenerCampanasPorId,
  promediarUtilidad,
  obtenerRecurrencia,
  obtenerTiempoDeVida,
  promediarUtilidadPorFecha,
  obtenerRecurrenciaPorFecha,
  obtenerTiempoDeVidaPorFecha,
} from '../../../actions/CampanasAction';

const columns = [
  { id: 'cliente', label: 'CLIENTE', minWidth: 10 },
  { id: 'ci', label: 'NRO CEDULA', minWidth: 100 },
  { id: 'ruc', label: 'RUC', minWidth: 10 },
  { id: 'fecgra', label: 'FECHA DE INGRESO', minWidth: 100 },
  { id: 'ltv', label: 'LTV', minWidth: 100 },
];

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
});

export default function TMetricas({ campana_id, radio, desde, hasta }) {
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [campana, setCampana] = useState([]);
  const [clientesAlcanzados, setClientesAlcanzados] = useState(0);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [cliente, setCliente] = useState({});
  const [promedioUtilidad, setPromedioUtilidad] = useState(0);
  const [recurrencia, setRecurrencia] = useState(0);
  const [tiempodeVida, setTiempoDeVida] = useState(0);
  const [mostrarCardLTV, setMostrarCardLTV] = useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const CalcularLTVGeneral = (cliente) => {
    setCliente(cliente);

    promediarUtilidad(campana_id, cliente.ci !==null && cliente.ci !=="" ? cliente.ci:cliente.ruc).then((response) => {
      if (response.status === 200) {
        setPromedioUtilidad(parseInt(response.data.prom));
      }
    });
    obtenerRecurrencia(campana_id, cliente.ci !==null && cliente.ci !=="" ? cliente.ci:cliente.ruc).then((response) => {
      if (response.status === 200) {
        setRecurrencia(response.data.total);
      }
    });
    obtenerTiempoDeVida(campana_id, cliente.ci !==null && cliente.ci !=="" ? cliente.ci:cliente.ruc).then((response) => {
      if (response.status === 200) {
        setTiempoDeVida(response.data.cuenta);
      }
    });
    setMostrarCardLTV(true);
  };

  const CalcularLTVPorFecha = (cliente) => {
    setCliente(cliente);
    let fechadesde =
      desde.getFullYear() +
      '-' +
      (desde.getMonth() + 1).toString().padStart(2, '0') +
      '-' +
      desde.getDate().toString().padStart(2, '0') +
      'T00:00:00';
    let fechahasta =
      hasta.getFullYear() +
      '-' +
      (hasta.getMonth() + 1).toString().padStart(2, '0') +
      '-' +
      hasta.getDate().toString().padStart(2, '0') +
      'T00:00:00';
    const objeto = {
      DESDE: fechadesde,
      HASTA: fechahasta,
      CAMPANA_Id: campana_id,
      CODCLIENTE: cliente.ci !==null && cliente.ci !=="" ? cliente.ci:cliente.ruc,
    };
    promediarUtilidadPorFecha(objeto).then((response) => {
      if (response.status === 200) {
        setPromedioUtilidad(parseInt(response.data.prom));
      }
    });
    obtenerRecurrenciaPorFecha(objeto).then((response) => {
      if (response.status === 200) {
        setRecurrencia(response.data.total);
      }
    });
    obtenerTiempoDeVidaPorFecha(objeto).then((response) => {
      if (response.status === 200) {
        setTiempoDeVida(response.data.cuenta);
      }
    });
    setMostrarCardLTV(true);
  };

  useEffect(() => {
    if (radio === 'General') {
      obtenerClientesPorCampana(campana_id).then((response) => {
        if (response.status === 200) {
          setRows(response.data);
        }
      });
      obtenerCampanasPorId(campana_id).then((response) => {
        if (response.status === 200) {
          setCampana(response.data);
        }
      });
      obtenerAlcanceDeCampana(campana_id).then((response) => {
        if (response.status === 200) {
          setClientesAlcanzados(response.data.cuenta);
        }
      });
      setMostrarCardLTV(false);
    } else {
      let fechadesde =
        desde.getFullYear() +
        '-' +
        (desde.getMonth() + 1).toString().padStart(2, '0') +
        '-' +
        desde.getDate().toString().padStart(2, '0') +
        'T00:00:00';
      let fechahasta =
        hasta.getFullYear() +
        '-' +
        (hasta.getMonth() + 1).toString().padStart(2, '0') +
        '-' +
        hasta.getDate().toString().padStart(2, '0') +
        'T00:00:00';
      let objeto = {
        DESDE: fechadesde,
        HASTA: fechahasta,
        CAMPANA_Id: campana_id,
      };
      obtenerClientesPorCampanaFecha(objeto).then((response) => {
        if (response.status === 200) {
          setRows(response.data);
        }
      });
      obtenerCampanasPorId(campana_id).then((response) => {
        if (response.status === 200) {
          setCampana(response.data);
        }
      });
      obtenerAlcanceDeCampanaPorFecha(objeto).then((response) => {
        if (response.status === 200) {
          setClientesAlcanzados(response.data.cuenta);
        }
      });
      setMostrarCardLTV(false);
    }
  }, [campana_id, desde, hasta, radio]);
  if (radio === 'General') {
    return (
      <Paper className={classes.root}>
        <Card>
          <CardContent>
            <Typography align="center" component="h1" variant="h6">
              Datos de la campaña:
            </Typography>
            <br />
            <Typography>Descripción: {campana.descricampana}</Typography>
            <br />
            <Typography>
              Presupuesto: {Intl.NumberFormat('es').format(campana.presupuesto)}
            </Typography>
            <br />
            <Typography>Clientes Alcanzados: {clientesAlcanzados}</Typography>
            <br />
            <Typography>
              CAC={' '}
              {clientesAlcanzados === 0 || clientesAlcanzados === null
                ? 0
                : Intl.NumberFormat('es').format(
                    campana.presupuesto / clientesAlcanzados
                  )}{' '}
              Gs Por cliente
            </Typography>
          </CardContent>
        </Card>
        <br />

        {mostrarCardLTV === true ? (
          <div>
            <Card>
              <CardContent>
                <Typography align="center" component="h1" variant="h6">
                  Cálculo LTV del Cliente:{' '}
                  {cliente.nombre + ' ' + cliente.apellido}
                </Typography>
                <br />
                <Typography>
                  Utilidad de las Ventas realizadas al Cliente:{' '}
                  {Intl.NumberFormat('es').format(promedioUtilidad)}
                </Typography>
                <br />
                <Typography>
                  Recurrencia (Cantidad de Productos Comprados): {recurrencia}
                </Typography>
                <br />
                <Typography>
                  Tiempo de Vida Medio (Cantidad de Ventas al Cliente):{' '}
                  {tiempodeVida}
                </Typography>
                <br />
                <Typography>
                  LTV (LIFE TIME VALUE):{' '}
                  {Intl.NumberFormat('es').format(
                    promedioUtilidad * recurrencia * tiempodeVida
                  )}
                </Typography>
              </CardContent>
            </Card>
          </div>
        ) : null}
        <Typography align="center" component="h1" variant="h6">
          {' '}
          Clientes Alcanzados{' '}
        </Typography>
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((cliente) => {
                return (
                  <TableRow
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={cliente.clientE_Id}
                  >
                    <TableCell align="left">
                      {cliente.nombre + ' ' + cliente.apellido}
                    </TableCell>
                    <TableCell align="left">{cliente.ci}</TableCell>
                    <TableCell align="left">{cliente.ruc}</TableCell>
                    <TableCell align="left">
                      {cliente.fecgra.substr(0, 10)}
                    </TableCell>
                    <TableCell>
                      <Button
                        color="primary"
                        onClick={() => CalcularLTVGeneral(cliente)}
                      >
                        Calcular
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    );
  } else {
    return (
      <Paper className={classes.root}>
        <Card>
          <CardContent>
            <Typography align="center" component="h1" variant="h6">
              Datos de la campaña:
            </Typography>
            <br />
            <Typography>Descripción: {campana.descricampana}</Typography>
            <br />
            <Typography>
              Presupuesto: {Intl.NumberFormat('es').format(campana.presupuesto)}
            </Typography>
            <br />
            <Typography>Clientes Alcanzados: {clientesAlcanzados}</Typography>
            <br />
            <Typography>
              CAC={' '}
              {clientesAlcanzados === 0 || clientesAlcanzados === null
                ? 0
                : Intl.NumberFormat('es').format(
                    campana.presupuesto / clientesAlcanzados
                  )}{' '}
              Gs Por cliente
            </Typography>
          </CardContent>
        </Card>
        <br />
        {mostrarCardLTV === true ? (
          <div>
            <Card>
              <CardContent>
                <Typography align="center" component="h1" variant="h6">
                  Cálculo LTV del Cliente:{' '}
                  {cliente.nombre + ' ' + cliente.apellido}
                </Typography>
                <br />
                <Typography>
                  Utilidad de las Ventas realizadas al Cliente:{' '}
                  {Intl.NumberFormat('es').format(promedioUtilidad)}
                </Typography>
                <br />
                <Typography>
                  Recurrencia (Cantidad de Productos Comprados): {recurrencia}
                </Typography>
                <br />
                <Typography>
                  Tiempo de Vida Medio (Cantidad de Ventas al Cliente):{' '}
                  {tiempodeVida}
                </Typography>
                <br />
                <Typography>
                  LTV (LIFE TIME VALUE):{' '}
                  {Intl.NumberFormat('es').format(
                    promedioUtilidad * recurrencia * tiempodeVida
                  )}
                </Typography>
              </CardContent>
            </Card>
          </div>
        ) : null}
        <Typography align="center" component="h1" variant="h6">
          {' '}
          Clientes Alcanzados{' '}
        </Typography>
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((cliente) => {
                return (
                  <TableRow
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={cliente.clientE_Id}
                  >
                    <TableCell align="left">
                      {cliente.nombre + ' ' + cliente.apellido}
                    </TableCell>
                    <TableCell align="left">{cliente.ci}</TableCell>
                    <TableCell align="left">{cliente.ruc}</TableCell>
                    <TableCell align="left">
                      {cliente.fecgra.substr(0, 10)}
                    </TableCell>
                    <TableCell>
                      <Button
                        color="primary"
                        onClick={() => CalcularLTVPorFecha(cliente)}
                      >
                        Calcular
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    );
  }
}
